import React, { useEffect, useRef, useState } from "react";

export const useHtmlAnswerKey = ({
  selectedText,
  setSelectedText,
  setOpenErrMsgDialog,
  htmlUrl = null,
  data = {}
}) => {
  const [htmlContent, setHtmlContent] = useState("");
  const iframeRef = useRef(null);
  const { characterLimit } =
    data?.data?.answerkey?.frontend_Validation || {}

  useEffect(() => {
    if (!!htmlUrl) {
      fetch(htmlUrl)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          doc.querySelectorAll("div.t").forEach((div) => {
            if (!div.textContent.trim()) {
              div.remove();
            }
            // will be needed for complex book,
            //  else {
            //   const fullText = div.textContent.trim();
            //   div.innerHTML = `${fullText}`;
            // }
          });

          const cleanedHtml = doc.documentElement.innerHTML;
          const modifiedHtml = `
                ${cleanedHtml}
                <style>
                  .highlight { background-color: yellow; }
                  .selected { background-color: lightblue !important; }
                </style>
                <script>
                  function getBottomPosition(lineDiv) {
                    const computedStyle = window.getComputedStyle(lineDiv);
                    return parseFloat(computedStyle.bottom) || 0;
                  }

                  function groupParagraphs(lineDivs, threshold = 28) {
                    const paragraphGroups = [];
                    let currentGroup = [];
                    let previousBottom = 0;

                    lineDivs.forEach((div) => {
                      const currentBottom = getBottomPosition(div);

                      if (currentGroup.length === 0) {
                        currentGroup.push(div);
                      } else {
                        if (Math.abs(currentBottom - previousBottom) <= threshold) {
                          currentGroup.push(div);
                        } else {
                          paragraphGroups.push([...currentGroup]);
                          currentGroup = [div];
                        }
                      }
                      previousBottom = currentBottom;
                    });

                    if (currentGroup.length > 0) {
                      paragraphGroups.push(currentGroup);
                    }

                    return paragraphGroups;
                  }

                  function highlightParagraph(lineDiv) {
                    const parentDiv = lineDiv.parentElement;
                    const lineDivs = Array.from(parentDiv.children);
                    const threshold = 28;

                    const paragraphGroups = groupParagraphs(lineDivs, threshold);
                    const hoveredBottom = getBottomPosition(lineDiv);

                    paragraphGroups.forEach(group => {
                      const isGroupMatch = group.some(div => {
                        const divBottom = getBottomPosition(div);
                        return Math.abs(divBottom - hoveredBottom) <= threshold;
                      });

                      group.forEach(div => {
                        if (isGroupMatch) {
                          div.classList.add('highlight');
                        } else {
                          div.classList.remove('highlight');
                        }
                      });
                    });
                  }

                  function removeHighlight() {
                    document.querySelectorAll('.highlight').forEach(div => {
                      div.classList.remove('highlight');
                    });
                  }

                  document.addEventListener("DOMContentLoaded", () => {
                    characterLimit=${characterLimit}
                    document.querySelectorAll('div.t').forEach(lineDiv => {
                          lineDiv.addEventListener('mouseover', () => {
                        removeHighlight();
                        highlightParagraph(lineDiv);
                      });

                      lineDiv.addEventListener('mouseout', removeHighlight);
                    lineDiv.addEventListener('click', () => {
                    const parentDiv = lineDiv.parentElement;
                    const lineDivs = Array.from(parentDiv.children);
                    const threshold = 28;

                     const paragraphGroups = groupParagraphs(lineDivs, threshold);
                     const hoveredBottom = getBottomPosition(lineDiv);

                    let matchedGroup = [];

                     paragraphGroups.forEach(group => {
                     const isGroupMatch = group.some(div => {
                     const divBottom = getBottomPosition(div);
                      return Math.abs(divBottom - hoveredBottom) <= threshold;
                 });

                     if (isGroupMatch) {
                      matchedGroup = group;
                        }
            });

                  const paragraphTextArray = matchedGroup.map(div => div.textContent.trim()).filter(Boolean);
                  const paragraphText = paragraphTextArray.join(" ");
                  const isAlreadySelected = matchedGroup[0]?.classList.contains('selected');

                 if (!isAlreadySelected) {
               
                 const selectedDivs = Array.from(document.querySelectorAll("div.t.selected"));
                 const selectedTextLength = selectedDivs.reduce((total, div) => total + div.textContent.trim().length, 0);
                 const newParagraphLength = paragraphText.length;

                 if (characterLimit && (selectedTextLength + newParagraphLength + 200 >characterLimit)) {
                
                   window.parent.postMessage(
                       { type: "charLimitExceeded" },
                             "*"
                              );
                         return; // Don't apply selection
                }
                 }

                   matchedGroup.forEach(div => {
                    if (isAlreadySelected) {
                   div.classList.remove('selected');
                   } else {
                     div.classList.add('selected');
                        }
                         });

                     window.parent.postMessage(
                       { type: 'selectedText', text: paragraphTextArray, deselect: isAlreadySelected },
                            '*'
                           );
                        });

                    });
                  });

                  window.addEventListener("message", (event) => {
                  if (event.data.type === "preselectText") {
                    const selectedTextArray = event.data.text;

                     document.querySelectorAll("div.t.selected").forEach(div => {
                        div.classList.remove("selected");
                      });

                    const allDivs = Array.from(document.querySelectorAll("div.t"));
                    const paragraphGroups = groupParagraphs(allDivs, 28);

                    paragraphGroups.forEach((group) => {
                      const groupText = group.map(div => div.textContent.trim()).filter(Boolean);
                      const groupTextJoined = groupText.join(" ");

                      if (
                        selectedTextArray.some(selected =>
                          groupTextJoined.trim() === selected.trim()
                        )
                      ) {
                        group.forEach(div => div.classList.add("selected"));
                      }
                    });
                  }
                });
                </script>

              `;
          setHtmlContent(modifiedHtml);
        })
        .catch((error) => console.error("Error loading HTML:", error));
    }
  }, [htmlUrl]);

  useEffect(() => {
    if (iframeRef.current) {
      iframeRef.current.contentWindow.postMessage(
        { type: "preselectText", text: selectedText },
        "*"
      );
    }
  }, [selectedText]);

  useEffect(() => {
    if (iframeRef.current && htmlContent) {
      const doc = iframeRef.current.contentDocument;
      doc.open();
      doc.write(htmlContent);
      doc.close();
    }
    if (iframeRef.current && selectedText.length > 0) {
      iframeRef.current.contentWindow.postMessage(
        { type: "preselectText", text: selectedText },
        "*"
      );
    }
  }, [htmlContent]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.type === "selectedText") {
        setSelectedText((prevSelected) => {
          const prevLength = prevSelected.reduce(
            (acc, cur) => acc + cur.length,
            0
          );

          const currentLength = event.data.text.reduce(
            (acc, curr) => acc + curr.length,
            0
          );

          if (event.data.deselect) {
            return prevSelected.filter(
              (text) => !event.data.text.join(" ").includes(text)
            );
          } else if (prevLength + currentLength + 200 < characterLimit) {
            return [...prevSelected, event.data.text.join(" ")];
          } else {
            return prevSelected;
          }
        });
      }
      if (event.data.type === "charLimitExceeded") {
        setOpenErrMsgDialog((draft) => {
          draft.open = true;
          return draft;
        });
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [characterLimit]);

  return {
    iframeRef,
  };
};
